import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Boom from "../components/boom"

import Layout from "../components/layout"
import Seo from "../components/seo"

const CmsPage = () => (
  <Layout>
    <Seo title="CMS whatsapp online website" />

    <div className="col-12 col-md-12 p-3 p-md-5 text-center"
      style={{
      backgroundRepeat: 'no-repeat',
		  backgroundAttachment: 'fixed',
      backgroundPosition: 'center', 
      backgroundSize: 'cover',
      backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}
      >
	  
<div class="card shadow rounded bg-warning p-3 p-md-5"
        style={{
          backgroundRepeat: 'repeat',
          backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
    }}
      >
	 <div className="p-3 p-md-5 card shadow rounded bg-dark text-white">
<h1><a href="/cms" className="text-white">Content Management System</a></h1>
 <StaticImage
 class="rounded shadow"
      src="../images/cmss.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
      style={{ marginBottom: `1.45rem` }}
    />
<p>Whatsapp Shop apps sendiri sudah dilengkapi dengan backend fitur untuk kebutuhan update dan melakukan berbagai perubahan pada website mu, dengan content management system whatsapp ini pun kamu bisa dengan mudah untuk melakukan berbagai pekerjaan untuk update data menu makanan minuman dan produk jual kamu, hingga kebutuhan untuk melakukan transaksi via point of sale applikasi kasir yang simple dan dapat digunakan dengan mesin kasir mu serta include dengan laporan pendapatan omset income detail memudahkan untuk berbagai kebutuhan kamu tentunya, paket POS apps ini sendiri bisa kamu dapatin dengan menggunakan layanan premium whatshop.
</p>
<p>
Pada fitur ini kita bisa membuat database untuk bekerja misal nya memasukan data menu dan produk , merubah desain tampilan awal halaman home page, update tata cara pembayaran, dan update QRIS Code payment mu, hingga kemudahan untuk update contact dan lain nya.
</p>
<p>
Dan dengan login system untuk akses whatshop app dilengkapi dengan username dan password.
</p>
<h3><Link to="/price" class="btn btn-warning"  
style={{
backgroundRepeat: 'repeat',
backgroundImage: `url(${('https://1.bp.blogspot.com/-Mw0xEaVY3aw/YWxR8l4N5BI/AAAAAAAAKPA/__XP598b-qwL__tfZ5ia4UNL-EHcT3h-wCLcBGAsYHQ/s84/bgs.jpg')})`
}}>Pilih Layanan Mu</Link></h3>
</div>
          </div>
        </div>
		<Boom/>
      </Layout>
)

export default CmsPage
